import React, { useState, useEffect } from "react";
import SubHead from "./SubHead";
import imgJob1 from "../../assets/img_job_01.jpg";
import imgJob2 from "../../assets/img_job_02.jpg";
import imgJob3 from "../../assets/img_job_03.jpg";
import imgJob4 from "../../assets/img_job_04.jpg";
import imgJob5 from "../../assets/img_job_05.jpg";
import imgJob6 from "../../assets/img_job_06.jpg";
import imgJob7 from "../../assets/img_job_07.jpg";
import ScrollOut from "scroll-out";

const Introduction = () => {
    useEffect(() => {
        ScrollOut({
            threshold: 0.3,
            once: true
        });
    }, []);

    return (
        <>
            <SubHead title="직무소개" eng="JOB introduction"></SubHead>
            <main className="sub-contents">
                <div className="inner">
                    <ul className="job_introduct_ul">
                        <li data-scroll>
                            <div className="img_box">
                                <img src={imgJob1} alt="이미지" />
                            </div>
                            <div className="text_box">
                                <p className="num">01</p>
                                <p className="sbj">무선 네트워크 설비 운용</p>
                                <p className="txt">무선 네트워크 설비 운용, 재난안전통신망, 5G, 4G, LTE, WIFI 기지국 및 중계기 장비, 부대시설 유지보수</p>
                            </div>
                        </li>
                        <li data-scroll>
                            <div className="img_box">
                                <img src={imgJob2} alt="이미지" />
                            </div>
                            <div className="text_box">
                                <p className="num">02</p>
                                <p className="sbj">무선통신장비 설치, 개통</p>
                                <p className="txt">고객통화불편 해소를 위한 댁내형 중계기, GIGA-ATTO장비 설치 및 개통</p>
                            </div>
                        </li>
                        <li data-scroll>
                            <div className="img_box">
                                <img src={imgJob3} alt="이미지" />
                            </div>
                            <div className="text_box">
                                <p className="num">03</p>
                                <p className="sbj">네트워크 관제 및 원격 운용</p>
                                <p className="txt">네트워크 분석 및 감시, 장애 상황 감지 후 현장출동 요청</p>
                            </div>
                        </li>
                        <li data-scroll>
                            <div className="img_box">
                                <img src={imgJob4} alt="이미지" />
                            </div>
                            <div className="text_box">
                                <p className="num">04</p>
                                <p className="sbj">유선 네트워크 설비 운용</p>
                                <p className="txt">유선 IP Access 및 전원 설비 관리 및 운용</p>
                            </div>
                        </li>
                        <li data-scroll>
                            <div className="img_box">
                                <img src={imgJob5} alt="이미지" />
                            </div>
                            <div className="text_box">
                                <p className="num">05</p>
                                <p className="sbj">무선 통신환경 관리</p>
                                <p className="txt">고객통신품질 VOC접수 및 통신환경 음영지역 점검</p>
                            </div>
                        </li>
                        <li data-scroll>
                            <div className="img_box">
                                <img src={imgJob6} alt="이미지" />
                            </div>
                            <div className="text_box">
                                <p className="num">06</p>
                                <p className="sbj">이동기지국 설치, 운영</p>
                                <p className="txt">이벤트 발생시 원활한 통화&무선통신네트워크 서비스를 위한 이동기지국 설치 및 운용</p>
                            </div>
                        </li>
                        <li data-scroll>
                            <div className="img_box">
                                <img src={imgJob7} alt="이미지" />
                            </div>
                            <div className="text_box">
                                <p className="num">07</p>
                                <p className="sbj">유무선 통신 솔루션 개발</p>
                                <p className="txt">유무선 통신 업무 최적화를 위한 프로그램, 어플 등 솔루션 개발 수행</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </main>
        </>
    );
};

export default Introduction;
